/**
 * Klasör yapısını düzleştiren yardımcı fonksiyon
 */
export const flattenFolderStructure = (categories) => {
  if (!categories || !categories.formCategories) return [];
  
  const flatten = (folders, level = 0) => {
    let result = [];
    
    folders.forEach(folder => {
      result.push({
        value: folder.id.toString(),
        label: folder.title,
        fullPath: folder.title,
        level: level,
        parentId: folder.parentId
      });

      if (folder.detail && folder.detail.length > 0) {
        const children = flatten(folder.detail, level + 1);
        result = result.concat(children);
      }
    });

    return result;
  };

  return flatten(categories.formCategories);
};

/**
 * beforeunload event fonksiyonu
 */
export function handleBeforeUnload(e) {
  e.preventDefault();
  e.returnValue = '';
}

/**
 * PDF base64'ünü blob'a çeviren fonksiyon
 */
export const convertBase64ToBlob = (base64Data, type) => {
  const byteCharacters = atob(base64Data);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  return new Blob([byteArray], { type });
};

/**
 * Klasör yapısını oluşturma yardımcı fonksiyonları
 */
export const folderUtils = {
  // Ana klasörleri ve alt klasörleri grupla
  buildFolderTree: (folderOptions) => {
    const parentMap = {};
    
    // Önce ana haritayı oluştur
    folderOptions.forEach(folder => {
      if (!parentMap[folder.parentId]) {
        parentMap[folder.parentId] = [];
      }
      parentMap[folder.parentId].push(folder);
    });
    
    // Sadece üst seviye klasörleri döndür (parentId = 0 olanlar)
    return parentMap[0] || [];
  },

  // Bir klasörün alt klasörlerini getir
  getChildren: (parentId, folderOptions) => {
    return folderOptions.filter(folder => folder.parentId.toString() === parentId.toString());
  },

  // Bir klasörün alt klasörleri var mı kontrol et
  hasChildren: (folderId, folderOptions) => {
    return folderOptions.some(folder => folder.parentId.toString() === folderId.toString());
  }
};

/**
 * PDF işlemleri için yardımcı fonksiyonlar
 */
export const pdfUtils = {
  // PDF alanlarını tespit et
  detectPdfFields: (formFields) => {
    return formFields.filter(field => 
      (field.type === 'pdf' || field.type === 'pdfDocument') && 
      field.uploadedFiles && 
      field.uploadedFiles.length > 0
    );
  },

  // PDF URL'ini response'dan çıkar
  extractPdfUrl: (uploadResponse) => {
    if (!uploadResponse.data) return null;
    
    if (uploadResponse.data.pdf) {
      return uploadResponse.data.pdf;
    } else if (uploadResponse.data.url) {
      return uploadResponse.data.url;
    } else if (uploadResponse.data.Url) {
      return uploadResponse.data.Url;
    } else if (typeof uploadResponse.data === 'string') {
      return uploadResponse.data;
    }
    
    return null;
  }
};

/**
 * Form validasyon yardımcıları
 */
export const formValidation = {
  // Form verilerini validate et
  validateFormData: (formData) => {
    const errors = [];
    
    if (!formData.formTitle || formData.formTitle.trim() === '') {
      errors.push('Form başlığı gereklidir');
    }
    
    if (!formData.formFields || formData.formFields.length === 0) {
      errors.push('En az bir form alanı gereklidir');
    }
    
    return {
      isValid: errors.length === 0,
      errors
    };
  },

  // Form içeriği objesi oluştur
  createFormContent: (formData, userData) => {
    const newFormId = formData.formId || `form_${Math.floor(Math.random() * 1000000000000)}`;
    
    return {
      id: newFormId,
      title: formData.formTitle || '',
      description: formData.formDescription || '',
      fields: formData.formFields.map(field => {
        if (field.type === 'calculation') {
          return {
            ...field,
            calculationData: formData.calculationValues[field.id] || {}
          };
        }
        return field;
      }),
      settings: {
        ...formData.formSettings,
        documentControlEnabled: formData.formSettings.documentControlEnabled || false,
        documentPrefix: formData.formSettings.documentPrefix || 'DOK',
        documentCode: formData.formSettings.documentCode || '001',
        department: formData.formSettings.department || '',
        backgroundColor: formData.formSettings.backgroundColor || '#ffffff',
        titleColor: formData.formSettings.titleColor || '#000000',
        descriptionColor: formData.formSettings.descriptionColor || '#666666',
        submitButtonColor: formData.formSettings.submitButtonColor || '#1976d2',
        submitButtonTextColor: formData.formSettings.submitButtonTextColor || '#ffffff',
        fieldSize: formData.formSettings.fieldSize || 'medium',
        formWidth: formData.formSettings.formWidth || 'medium',
        submitButtonText: formData.formSettings.submitButtonText || 'Gönder',
        fontFamily: formData.formSettings.fontFamily || 'Roboto',
        fontSize: formData.formSettings.fontSize || 'medium',
        fieldBorderRadius: formData.formSettings.fieldBorderRadius || '4px',
        fieldBorderColor: formData.formSettings.fieldBorderColor || '#e0e0e0',
        fieldBackgroundColor: formData.formSettings.fieldBackgroundColor || '#ffffff',
        fieldFocusColor: formData.formSettings.fieldFocusColor || '#1976d2',
        animationEnabled: formData.formSettings.animationEnabled || false,
        animationType: formData.formSettings.animationType || 'fade',
        accessibilityEnabled: formData.formSettings.accessibilityEnabled || false,
        highContrastMode: formData.formSettings.highContrastMode || false,
        securityEnabled: formData.formSettings.securityEnabled || false,
        captchaEnabled: formData.formSettings.captchaEnabled || false,
        maxSubmissions: formData.formSettings.maxSubmissions || 1000
      },
      isPublished: true,
      publishedAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
      formLink: formData.formLink,
      logo: userData?.logoUrl,
    };
  }
};
